import React from "react";
import PasswordModal from "./PasswordModal";

const RoundsSection = ({
  roundDetails,
  isUpdatingRound,
  showPasswordModal,
  setShowPasswordModal,
  password,
  setPassword,
  message,
  handleNextStep,
}) => {
  const getActionButtonColor = () => {
    if (roundDetails.number === -1) {
      return "#27ae60";
    } else if (roundDetails.number === 0) {
      return roundDetails.allow_project_creation === 1 ? "#e74c3c" : "#27ae60";
    } else if (roundDetails.number === 1) {
      if (roundDetails.allow_reg === 1) return "#e74c3c";
      if (roundDetails.lock_choices === 0) return "#e74c3c";
      return "#3498db";
    } else if (roundDetails.number === 2) {
      if (roundDetails.lock_choices === 0) return "#e74c3c";
      if (roundDetails.allow_project_creation === 0) return "#27ae60";
      return "#3498db";
    } else if (roundDetails.number === 3) {
      if (roundDetails.allow_reg === 1) return "#e74c3c";
      if (roundDetails.lock_choices === 0) return "#e74c3c";
      return "#e74c3c";
    }
    return "#3498db";
  };

  const buttonColor = getActionButtonColor();

  return (
    <div className="rounds-section">
      <h1>Round Management</h1>

      <div style={{
        marginBottom: "20px",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "4px",
        backgroundColor: "#f9f9f9"
      }}>
        <h3 style={{ margin: "0 0 10px 0" }}>
          Current Round: {roundDetails.number}
        </h3>
        
        <div style={{ 
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#fff",
          borderRadius: "4px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
          <h3 style={{ margin: "0 0 10px 0" }}>
            {roundDetails.number === -1 ? "Programme Not Started" : 
             roundDetails.number === 0 ? "Initial Setup" : 
             `Round ${roundDetails.number}`}
          </h3>
          
          {/* <p style={{ margin: "0", color: "#666", whiteSpace: "pre-line" }}>
            {roundDetails.message || "No status message available"}
          </p> */}
        </div>

        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <button
            onClick={() => setShowPasswordModal(true)}
            disabled={isUpdatingRound}
            style={{
              padding: "10px 20px",
              backgroundColor: buttonColor,
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "16px",
              minHeight: "60px",
              width: "100%",
              maxWidth: "400px"
            }}
          >
            {roundDetails.message || "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoundsSection;